export class MainReport {
    DocumentName?: string
    CustomerName?: string
    WellName?: string
    ProjectName?: string
    AccountManager?: string
    FormationValue?: string
    ShaftType?: string
    Pump_HousingLoad?: string
    SurfaceCableLength?: string
    SurfaceCableLength_Unit?: string
    BearingType?: string
    Casing_Drift_ID?: string
    CasingDriftID_Unit?: string
    CustomerRep?: string
    WellApiNumber?: string
    PumpSettingMD?: string
    PumpSettingMD_Unit?: string
    PumpSettingVD?: string
    PumpSettingVD_Unit?: string
    Datum?: string
    Datum_Unit?: string
    ProductivityIndex?: string
    PI_Unit?: string
    StaticBHP?: string
    StaticBHP_Unit?: string
    StaticFL?: string
    StaticFL_Unit?: string
    FlowingBHP?: string
    FlowingBHP_Unit?: string
    ProductionFL?: string
    ProductionFL_Unit?: string
    Flop?: string
    Flop_Unit?: string
    PIP?: string
    Pump_PIP_Unit?: string
    ProductionRate?: string
    ProductionRate_Unit?: string
    TargetFlowRate?: string
    TargetFlowRate_Unit?: string
    BOPD?: string
    BOPD_Unit?: string
    BWPD?: string
    BWPD_Unit?: string
    GasProduction?: string
    GasProduction_Unit?: string
    OperatingFrequency?: string
    OilGravity?: string
    WaterGravity?: string
    WaterCut?: string
    BottomHoleTemprature?: string
    BottomHoleTemprature_Unit?: string
    SurfaceFluidTemprature?: string
    SurfaceFluidTemprature_Unit?: string
    GasGravity?: string
    BubblePoint?: string
    BubblePoint_Unit?: string
    GOR?: string
    GOR_Unit?: string
    GLR?: string
    GLR_Unit?: string
    TotalVolumeIntake?: string
    GasTFVUnit?: string
    OilRate?: string
    OilRate_Unit?: string
    WaterRate?: string
    WaterRate_Unit?: string
    GasRate?: string
    GasRate_Unit?: string
    FreeGasIntakePercent?: string
    PumpFreeGasPercent?: string
    PumpTDH?: string
    TotalTDH?: number
    RequiredSystemTDH?: number
    Pump_RequiredTDH?: string
    Pump_RequiredTDH_Unit?: string
    CompositeSG?: string
    LiquidPhaseSG?: string
    CasingOD?: string
    CasingOD_Unit?: string
    CasingWeight?: string
    CasingWeight_Unit?: string
    Casing?: string
    CasingID?: string
    CasingID_Unit?: string
    TubingOD?: string
    TubingOD_Unit?: string
    TubingWeight?: string
    TubingWeight_Unit?: string
    Tubing?: string
    TubingID?: string
    TubingID_Unit?: string
    TubingType?: string
    LinerOD?: string
    LinerOD_Unit?: string
    LinerWeight?: string
    LinerWeight_Unit?: string
    Liner?: string
    LinerID?: string
    LinerID_Unit?: string
    CasingPressure?: string
    CasingPressure_Unit?: string
    TubingPressure?: string
    TubingPressure_Unit?: string
    Surface_SurfaceVoltage?: string
    Surface_SurfaceVoltage_Unit?: string
    Surface_DriveAmps?: string
    Surface_DriveAmps_Unit?: string
    Surface_KVARequired?: string
    Surface_KVARequired_Unit?: string
    Surface_KWRequired?: string
    Surface_KWRequired_Unit?: string
    Surface_SupplyVoltage?: string
    Surface_SupplyVoltage_Unit?: string
    Controller?: string
    Cable?: string
    Pump?: string
    PumpNoOfStages?: string
    Gas_GasSeparator?: string
    GasSep_NoOfSeparator?: string
    GKX?: string
    IsGKXVisible?: boolean
    Gas_ChargePump1?: string
    Gas_ChargePump1_Stages?: string
    Gas_ChargePump2?: string
    Gas_ChargePump2_Stages?: string
    Gas_ChargePump3?: string
    Gas_ChargePump3_Stages?: string
    IsGasChargePumpsVisible?: boolean
    IsGasChargePumps2Visible?: boolean
    IsGasChargePumps3Visible?: boolean
    UpperProtector?: string
    LowerProtector?: string
    Motor?: string
    MotorPower?: string
    MotorPowerUnit?: string
    MotorVoltage?: string
    MotorVoltageUnit?: string
    MotorCurrent?: string
    MotorCurrentUnit?: string
    MotorKW?: string
    graph1Data?: string
    graph1DataMaximum?: string
    graph1DataMajorStep?: string
    graph1DataPowerMaximum?: string
    graph1DataPowerMajorStep?: string
    graph1DataEfficiencyMaximum?: string
    graph1DataEfficiencyMajorStep?: string
    graph1DataHeadMaximum?: string
    graph1DataHeadMajorStep?: string
    graph1DataHeadAxisTitle?: string
    graph1DataPowerAxisTitle?: string
    graph1DataCapacityAxisTitle?: string
    graph2Data?: string
    graph2DataHeadMaximum?: string
    graph2DataHeadMajorStep?: string
    graph2DataMaximum?: string
    graph2DataMajorStep?: string
    graph2DataHeadAxisTitle?: string
    graph2DataCapacityAxisTitle?: string
    graph3Data?: string
    graph3DataHeadMaximum?: string
    graph3DataHeadMajorStep?: string
    graph3DataPowerAxisTitle?: string
    graph3DataCapacityAxisTitle?: string
    graph3DataMaximum?: string
    graph3DataMajorStep?: string
    GasAnchorOD?: string
    GasAnchorODUnit?: string
    GasAnchorID?: string
    GasAnchorIDUnit?: string
    GasAnchorTubingOD?: string
    GasAnchorTubingODUnit?: string
    IsGasAnchorVisible?: boolean
    GasAnchorNatSepEff?: string
    GasAnchorFreeGasIntake?: string
    GasAnchorFreeGasDischarge?: string
    GasAnchorTFVIntake?: string
    GasAnchorTFVIntakeUnit?: string
    GasAnchorTFVDischarge?: string
    GasAnchorTFVDischargeUnit?: string
    GasSep_FreeGasDischarge?: string
    GasSep_TVFIntake?: string
    GasSep_TFVDischarge?: string
    GasSep_PressureIntake?: string
    GasBOIPressureDischarge?: string
    GKX_FreeGasIntake?: string
    GKX_FreeGasDischarge?: string
    GKX_TFVIntake?: string
    GKX_TFVDischarge?: string
    GKX_PressureIntake?: string
    GKX_PressureDischarge?: string
    FC_FreeGasIntake?: string
    FC_FreeGasDischarge?: string
    FC_TFVIntake?: string
    FC_TFVDischarge?: string
    FC_IntakePressure?: string
    FC_DischargePressure?: string
    Pump_DesiredFlowRate?: string
    Pump_DesiredFlowRateUnit?: string
    Pump_ShaftType?: string
    ClearanceGraph1?: string
    ClearanceGraph2?: string
    ClearanceGraph3?: string
    ClearanceGraph4?: string
    Motor_PowerRequired?: string
    Motor_PowerRequired_Unit?: string
    Motor_OD?: string
    Motor_OD_Unit?: string
    Motor_NamePlatePower?: string
    Motor_NamePlatePower_Unit?: string
    Motor_NamePlateVoltage?: string
    Motor_NamePlateVoltageUnit?: string
    Motor_NamePlateCurrent?: string
    Motor_NamePlateCurrentUnit?: string
    Motor_OperatingEfficiency?: string
    Motor_LoadAt60Hz?: string
    Motor_OperatingCurrent?: string
    Motor_OperatingVoltage?: string
    Motor_OperatingTemperature?: string
    Motor_OperatingTemperatureUnit?: string
    Motor_OperatingSpeed?: string
    Motor_OperatingSpeedUnit?: string
    Motor_OperatingPower?: string
    Motor_OperatingPowerUnit?: string
    Motor_OperatingPowerFactor?: string
    Motor_Velocity?: string
    Motor_VelocityUnit?: string
    Motor_Sensor?: string
    Sensor?: string
    Protector_ProtectorName1?: string
    Protector_ProtectorName2?: string
    Protector_BearingLoad?: string
    Protector_ShaftLoad?: string
    Protector_LT_Operation_1?: string
    Protector_LT_Operation_2?: string
    Protector_LT_Operation_3?: string
    Protector_UT_Operation_1?: string
    Protector_UT_Operation_2?: string
    Protector_UT_Operation_3?: string
    Protector_LT_Pull_1?: string
    Protector_LT_Pull_2?: string
    Protector_LT_Pull_3?: string
    Protector_UT_Pull_1?: string
    Protector_UT_Pull_2?: string
    Protector_UT_Pull_3?: string
    Cable_CableType?: string
    Cable_EstCableLength?: string
    Cable_EstCableLength_Unit?: string
    Cable_VoltageLoss?: string
    CablVoltLoss1000?: string
    CableMaxConductorTemp?: string
    CableConductorTempDesign?: string
    CableAmpacity?: string
    CableVDrop?: string
    DriftID?: string
    NominalID?: string
    CasingNominalID?: string
    Cable_Clearance1?: string
    Cable_Clearance2?: string
    Cable_Clearance3?: string
    Cable_Clearance4?: string
    Cable_Clearance_Unit?: string
    Surface_ControllerType?: string
    Surface_Controller?: string
    Surface_PercentageControllerLoad?: string
    Surface_PowerFactor?: string
    Surface_ElectricalCost?: string
    Surface_ElectricalCost_Unit?: string
    Pump_HousingPressure?: string
    Pump_PercentShaftLoad?: string
    Pump_IntakePressure?: string
    Pump_TFVIntake?: string
    Pump_FreeGasIntake?: string
    Pump_FreeGasDischarge?: string
    Pump_PressureDischarge?: string
    Pump_TFVDischarge?: string
    IPRGraphData?: string
    DepletionGraphData?: string
    depletionGraphDataXMax?: string
    depletionGraphDataYMax?: string
    iprGraphDataMaxXAxis?: string
    iprGraphDataMaxYAxis?: string
    iprGraphDataXAxisInterval?: string
    iprGraphDataYAxisInterval?: string
    depletionGraphDataXAxisInterval?: string
    depletionGraphDataYAxisInterval?: string
    ShowIPRPlotOnMainReport?: boolean
    ShowDepletionPlotOnMainReport?: boolean
    MotorDerating_HP?: string
    MotorDerating_Voltage?: string
    MotorDerating_Amps?: string
    MotorDeratingPercent?: string
    WellSurveyGraphData1?: string
    EspLength?: string
    KOP?: string
    TailPipeDesander?: string
    BottomOfEspSensor?: string
    TopOfEspPump?: string
    MaxDLSAboveKOP?: string
    TransitionZone?: string
    TailPipeTZ?: string
    DepthOfMaxDLS?: string
    TailPipeBtm?: string
    INCMax1?: string
    DLSMax1?: string
    INCMax2?: string
    DLSMax2?: string
    MDMax1?: string
    MDMax2?: string
    MinMd1?: string
    MinMd2?: string
    WellSurveyGraphData2?: string
    TubingDLS?: string
    TubingMd?: string
    ShowWellSurveyGraph?: boolean
    WellSurveyCasingSize?: string
    WellSurveyTubingSize?: string
    OilApi?: string
    Notes?: string
    HarmonicFilterSelection?: string
    IsHarmonicFilterVisible?: boolean
    GKXShaftLoading?: string
    GKXEfficiency?: string
    GKXTotalPower?: string
    GKXFinalTDH?: string
    GKXLiftStage?: string
    GKXShaftType?: string
    GKXNoOfStage?: string
    ChgPum3Efficiency?: string
    ChgPum2Efficiency?: string
    ChgPum1Efficiency?: string
    ChgPum3TotalPower?: string
    ChgPum2TotalPower?: string
    ChgPum1TotalPower?: string
    ChgPum3FinalTDH?: string
    ChgPum2FinalTDH?: string
    ChgPum1FinalTDH?: string
    ChgPum3LiftStage?: string
    ChgPum2LiftStage?: string
    ChgPum1LiftStage?: string
    ChgPum3ShaftType?: string
    ChgPum2ShaftType?: string
    ChgPum1ShaftType?: string
    ChargPmp1_FreeGasIntake?: string
    ChargPmp1_FreeGasDischarge?: string
    ChargPmp2_FreeGasIntake?: string
    ChargPmp2_FreeGasDischarge?: string
    ChargPm1ShaftLoading?: string
    ChargPmp2ShaftLoading?: string
    ChargPmp3ShaftLoading?: string
    Region?: string
    ChargPmp1_TFVIntake?: string
    ChargPmp2_TFVIntake?: string
    ChargPmp3_TFVIntake?: string
    ChargPmp1_TFVDischarge?: string
    ChargPmp2_TFVDischarge?: string
    ChargPmp3_TFVDischarge?: string
    BHPGasHandlerOnly?: string
    BHPChargPmp1Only?: string
    BHPChargPmp2Only?: string
    BHPChargPmp3Only?: string
    ChargPmp1_PressureIntake?: string
    ChargPmp2_PressureIntake?: string
    ChargPmp3_PressureIntake?: string
    ChargPmp1_PressureDischarge?: string
    ChargPmp2_PressureDischarge?: string
    ChargPmp3_PressureDischarge?: string
    CaseName?: string
    Pump_TotalPower?: string
    Case_ModifiedDate?: string
  
    ShowSchematicData?: boolean
    SR_VSDDrive?: string
    SR_VSDDrivePN?: string
    SR_Transformer?: string
    SR_HarmonicFilterPN?: string
    SR_PumpSeries?: string
  
    SR_EOTubing?: string
    SR_IntakeSetDepth?: string
    SR_ESPBottomSetDepth?: string
    SR_SetDepth?: string
    SR_ESPLength?: string
    SR_ESPTailPipeDesanderLength?: string
    SR_DownholeESPWeight?: string
    SR_CableName?: string
    SR_CablePN?: string
    SR_CableLength?: string
    SR_CableWeight?: string
    SR_CableDimension?: string
    SR_MLEName?: string
    SR_MLEPN?: string
    SR_MLELength?: string
    SR_MLEWeight?: string
    SR_MLEDimension?: string
    SR_BOHName?: string
    SR_BOHPN?: string
    SR_BOHLength?: string
    SR_BOHWeight?: string
    SR_BOHSetDepth?: string
  
    SR_Pump1Name?: string
    SR_Pump1PN?: string
    SR_Pump1Length?: string
    SR_Pump1Weight?: string
    SR_Pump1SetDepth?: string
    SR_Pump2Name?: string
    SR_Pump2PN?: string
    SR_Pump2Length?: string
    SR_Pump2Weight?: string
    SR_Pump2SetDepth?: string
    SR_Pump3Name?: string
    SR_Pump3PN?: string
    SR_Pump3Length?: string
    SR_Pump3Weight?: string
    SR_Pump3SetDepth?: string
    SR_Pump4Name?: string
    SR_Pump4PN?: string
    SR_Pump4Length?: string
    SR_Pump4Weight?: string
    SR_Pump4SetDepth?: string
    SR_GasHandler1Name?: string
    SR_GasHandler1PN?: string
    SR_GasHandler1Length?: string
    SR_GasHandler1Weight?: string
    SR_GasHandler1SetDepth?: string
    SR_GasHandler2Name?: string
    SR_GasHandler2PN?: string
    SR_GasHandler2Length?: string
    SR_GasHandler2Weight?: string
    SR_GasHandler2SetDepth?: string
    SR_Protector1Name?: string
    SR_Protector1PN?: string
    SR_Protector1Length?: string
    SR_Protector1Weight?: string
    SR_Protector1SetDepth?: string
    SR_Protector2Name?: string
    SR_Protector2PN?: string
    SR_Protector2Length?: string
    SR_Protector2Weight?: string
    SR_Protector2SetDepth?: string
  
    SR_AccessoriesAboveESPName?: string
    SR_AccessoriesAboveESPPN?: string
    SR_AccessoriesAboveESPLength?: string
    SR_AccessoriesAboveESPWeight?: string
    SR_AccessoriesAboveESPSetDepth?: string
  
    SR_AccessoriesAboveESPName2?: string
    SR_AccessoriesAboveESPPN2?: string
    SR_AccessoriesAboveESPLength2?: string
    SR_AccessoriesAboveESPWeight2?: string
    SR_AccessoriesAboveESPSetDepth2?: string
  
    SR_AccessoriesAboveESPName3?: string
    SR_AccessoriesAboveESPPN3?: string
    SR_AccessoriesAboveESPLength3?: string
    SR_AccessoriesAboveESPWeight3?: string
    SR_AccessoriesAboveESPSetDepth3?: string
  
    SR_AccessoriesAboveESPName4?: string
    SR_AccessoriesAboveESPPN4?: string
    SR_AccessoriesAboveESPLength4?: string
    SR_AccessoriesAboveESPWeight4?: string
    SR_AccessoriesAboveESPSetDepth4?: string
  
    SR_GasSeperator1Name?: string
    SR_GasSeperator1PN?: string
    SR_GasSeperator1Length?: string
    SR_GasSeperator1Weight?: string
    SR_GasSeperator1SetDepth?: string
    SR_GasSeperator2Name?: string
    SR_GasSeperator2PN?: string
    SR_GasSeperator2Length?: string
    SR_GasSeperator2Weight?: string
    SR_GasSeperator2SetDepth?: string
    SR_GasSeperator3Name?: string
    SR_GasSeperator3PN?: string
    SR_GasSeperator3Length?: string
    SR_GasSeperator3Weight?: string
    SR_GasSeperator3SetDepth?: string
    SR_GasSeperator4Name?: string
    SR_GasSeperator4PN?: string
    SR_GasSeperator4Length?: string
    SR_GasSeperator4Weight?: string
    SR_GasSeperator4SetDepth?: string
    SR_MotorHeader?: string
    SR_Motor1Name?: string
    SR_Motor1PN?: string
    SR_Motor1Length?: string
    SR_Motor1Weight?: string
    SR_Motor1SetDepth?: string
    SR_Motor2Name?: string
    SR_Motor2PN?: string
    SR_Motor2Length?: string
    SR_Motor2Weight?: string
    SR_Motor2SetDepth?: string
    SR_Motor3Name?: string
    SR_Motor3PN?: string
    SR_Motor3Length?: string
    SR_Motor3Weight?: string
    SR_Motor3SetDepth?: string
    SR_Motor4Name?: string
    SR_Motor4PN?: string
    SR_Motor4Length?: string
    SR_Motor4Weight?: string
    SR_Motor4SetDepth?: string
    SR_SensorName?: string
    SR_SensorPN?: string
    SR_SensorLength?: string
    SR_SensorWeight?: string
    SR_SensorSetDepth?: string
    SR_DeSanderName?: string
    SR_DeSanderPN?: string
    SR_DeSanderLength?: string
    SR_DeSanderWeight?: string
    SR_DeSanderSetDepth?: string
    SR_TailPipeJoints?: string
    SR_TailPipePN?: string
    SR_TailPipeLength?: string
    SR_TailPipeWeight?: string
    SR_TailPipeSetDepth?: string
    SR_SurfaceCableLengthRequired?: string
    SR_SurfaceCableLengthType?: string
    SR_SurfaceCableLengthProvider?: string
    SR_SurfaceCableLengthQuantity?: string
    SR_CableClampsRequired?: string
    SR_CableClampsType?: string
    SR_CableClampsProvider?: string
    SR_CableClampsQuantity?: string
    SR_MLEClampsRequired?: string
    SR_MLEClampsType?: string
    SR_MLEClampsProvider?: string
    SR_MLEClampsQuantity?: string
    SR_MLEGuardRequired?: string
    SR_MLEGuardType?: string
    SR_MLEGuardProvider?: string
    SR_MLEGuardQuantity?: string
    SR_SandGuardRequired?: string
    SR_SandGuardType?: string
    SR_SandGuardProvider?: string
    SR_SandGuardQuantity?: string
    SR_DesanderRequired?: string
    SR_DesanderType?: string
    SR_DesanderProvider?: string
    SR_DesanderQuantity?: string
    SR_GasGuardRequired?: string
    SR_GasGuardType?: string
    SR_GasGuardProvider?: string
    SR_GasGuardQuantity?: string
    SR_DrainValveRequired?: string
    SR_DrainValveType?: string
    SR_DrainValveProvider?: string
    SR_DrainValveQuantity?: string
    SR_CheckValveRequired?: string
    SR_CheckValveType?: string
    SR_CheckValveProvider?: string
    SR_CheckValveQuantity?: string
    SR_CentralizerRequired?: string
    SR_CentralizerType?: string
    SR_CentralizerProvider?: string
    SR_CentralizerQuantity?: string
    SR_CTLineRequired?: string
    SR_CTLineType?: string
    SR_CTLineProvider?: string
    SR_CTLineQuantity?: string
    SR_Notes?: string
    SR_StartUpFreq?: string
    SR_MaxFrequency?: string
    SR_MinFreqatDeparture?: string
    SR_SurfVolts?: string
  
    SR_Pump5Name?: string
    SR_Pump5PN?: string
    SR_Pump5Length?: string
    SR_Pump5Weight?: string
    SR_Pump5SetDepth?: string
  
    SR_Pump6Name?: string
    SR_Pump6PN?: string
    SR_Pump6Length?: string
    SR_Pump6Weight?: string
    SR_Pump6SetDepth?: string
  
    SR_Pump7Name?: string
    SR_Pump7PN?: string
    SR_Pump7Length?: string
    SR_Pump7Weight?: string
    SR_Pump7SetDepth?: string
    SR_MLELengthSplice?: string
  }
